import React from 'react';
import PropTypes from 'prop-types';

import { InputContainer, InputElement, InputLabel } from './styles';

class Input extends React.Component {
    onChange = event => {
        var { NoDecimal, OnChange, Type } = this.props;

        var Value = event.target.value;

        if (Type.toLowerCase() === 'number') {
            if (!NoDecimal && ((/\d+\.?\d*/).test(Value) || Number(Value) === 0)) OnChange(event);
            else if (/^\d+$/.test(Value) || Number(Value) === 0) OnChange(event);
            
            // if (/^[0-9]+(\.[0-9]{1,2})?$/.test(Value) || Number(Value) === 0) OnChange(event);
            // if (/^\d+$/.test(Value) || Number(Value) === 0) OnChange(event);
        } else OnChange(event);
    }

    render() {
        var { Accept, AutoComplete, AutoFocus, Centered, Checked, className, Disabled, FontColor, FontFamily, FontSize, HtmlFor, Id, Label, LabelFontColor, Max, Min, NoLabel, NoMargin, OnBlur, OnFocus, OnKeyPress, Placeholder, ReadOnly, Size, Step, Type, Value } = this.props;

        return (
            <InputContainer className={`${className} InputContainer`} Centered={Centered} NoMargin={NoMargin}>
                {!NoLabel && <InputLabel Color={LabelFontColor}>{Label}</InputLabel>}
                
                <InputElement
                    className="InputElement"
                    accept={Accept}
                    autocomplete={AutoComplete || null}
                    autoFocus={AutoFocus}
                    Centered={Centered}
                    checked={Checked}
                    disabled={Disabled ? 'disabled' : null}
                    FontColor={FontColor}
                    FontFamily={FontFamily}
                    FontSize={FontSize}
                    htmlFor={HtmlFor}
                    id={Id}
                    max={Max}
                    min={Min}
                    onBlur={OnBlur}
                    onChange={this.onChange}
                    onFocus={OnFocus}
                    onKeyPress={OnKeyPress}
                    placeholder={Placeholder}
                    readOnly={ReadOnly}
                    size={Size}
                    step={Step}
                    type={Type}
                    value={Value !== null ? Value : ''}
                />
            </InputContainer>
            
        );
    }
}

Input.propTypes = {
    Accept: PropTypes.string,
    AutoComplete: PropTypes.string,
    AutoFocus: PropTypes.bool,
    Centered: PropTypes.bool,
    Checked: PropTypes.bool,
    Disabled: PropTypes.bool,
    FontColor: PropTypes.string,
    FontFamily: PropTypes.string,
    FontSize: PropTypes.string,
    HtmlFor: PropTypes.string,
    Icon: PropTypes.string,
    Id: PropTypes.string,
    Label: PropTypes.string,
    LabelFontColor: PropTypes.string,
    NoDecimal: PropTypes.bool,
    NoLabel: PropTypes.bool,
    NoMargin: PropTypes.bool,
    OnBlur: PropTypes.func,
    OnChange: function(props, propName, componentName) {
        if (!props.Disabled && !props.OnChange) return new Error(`Invalid prop ${propName} supplied to ${componentName}`)
    },
    OnFocus: PropTypes.func,
    OnKeyPress: PropTypes.func,
    Placeholder: PropTypes.string,
    ReadOnly: PropTypes.bool,
    Step: PropTypes.number,
    Size: PropTypes.string,
    Type: PropTypes.string.isRequired,
    Value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]).isRequired
};

export default Input;